/**
 * Decant Lab — variant selector
 * Desktop: pill buttons (delegated). Mobile: select dropdown (delegated).
 * Both update price display and the hidden variant ID input.
 */
(function () {
  // Pill clicks — delegated so it works for dynamically loaded cards (e.g. recommendations)
  document.addEventListener('click', function (e) {
    const pill = e.target.closest('.decant-card__pill');
    if (!pill || pill.disabled) return;

    const card = pill.closest('.decant-card__inline');
    if (!card) return;

    card.querySelectorAll('.decant-card__pill').forEach(p => p.classList.remove('is-selected'));
    pill.classList.add('is-selected');

    const priceVal     = card.querySelector('.decant-card__price-val');
    const variantInput = card.querySelector('.decant-card__form input.product-variant-id');
    if (priceVal)     priceVal.textContent  = pill.dataset.price;
    if (variantInput) {
      variantInput.value    = pill.dataset.variantId;
      variantInput.disabled = pill.dataset.available === 'false';
    }
  });

  // Mobile select — delegated
  document.addEventListener('change', function (e) {
    const select = e.target.closest('.decant-card__select');
    if (!select) return;

    const card = select.closest('.decant-card__inline');
    if (!card) return;

    const opt          = select.options[select.selectedIndex];
    const priceVal     = card.querySelector('.decant-card__price-val');
    const variantInput = card.querySelector('.decant-card__form input.product-variant-id');
    if (priceVal)     priceVal.textContent  = opt.dataset.price;
    if (variantInput) {
      variantInput.value    = opt.value;
      variantInput.disabled = opt.dataset.available === 'false';
    }
  });

  // Image click — still needs init since it sets cursor style
  function initImageClick(wrapper) {
    const url = wrapper.dataset.url;
    if (!url) return;
    const media = wrapper.querySelector('.card__media');
    if (media) {
      media.style.cursor = 'pointer';
      media.addEventListener('click', () => { window.location = url; });
    }
  }

  function initAll() {
    document.querySelectorAll('.product-card-wrapper').forEach(wrapper => {
      if (!wrapper.dataset.imgInit) {
        wrapper.dataset.imgInit = '1';
        initImageClick(wrapper);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(initAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
